import { createSlice } from '@reduxjs/toolkit';
import { RedactedSupplierIntegrationDetails } from '@dill/dill-shared';
import { getSupplierIntegrationDetailsExtraReducer } from '../reducers/supplierIntegrationDetailsReducers';

// A supplier's integration state as the browser is allowed to see it. Held separately from
// `currentSupplier` on purpose: `integrationDetails` lives in the supplierAdditionalDetails
// subcollection, is not part of the Supplier document, and its stored form holds ERP credentials
// that must not be serialized to the client. See supplierAdditionalDetailsControllers.ts.
export interface SupplierIntegrationDetailsInitialState {
  loadingList: string[];
  error: string | null;
  integrationDetails: RedactedSupplierIntegrationDetails | null;
  /** Which supplier `integrationDetails` describes, so a switch can discard the outgoing one. */
  supplierId: string | null;
}

const initialState: SupplierIntegrationDetailsInitialState = {
  loadingList: [],
  error: null,
  integrationDetails: null,
  supplierId: null,
};

export const supplierIntegrationDetailsSlice = createSlice({
  name: 'supplierIntegrationDetails',
  initialState,
  reducers: {
    resetSupplierIntegrationDetailsRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierIntegrationDetailsExtraReducer(builder);
  },
});

export const { resetSupplierIntegrationDetailsRootState } = supplierIntegrationDetailsSlice.actions;
